export default {
    props: ['productId', 'className'],
    computed: {
        favorites() {
            return this.$store.getters.getFavorites
        },
        isActive() {
            return this.favorites.includes(this.productId)
        }
    },
    methods: {
        onClickHandler() {
            if (this.isActive) {
                this.$store.dispatch('removeFavorite', this.productId)
            } else {
                this.$store.dispatch('addFavorite', this.productId)
            }
        }
    },
    // language=Vue
    template: `
      <div :class="[{'is-active': isActive}, className]"
           @click.prevent="onClickHandler"
      ></div>
    `
}